import Cookies from "js-cookie";
import { mobileWebviewActiveCookie } from "@shared/constants/react-native";

/**
 * Checks if the app is running in a React Native webview.
 * Reads the cookie set by new mobile app versions. Falls back to the DOM attribute
 * ("is-react-native-app") and /mobile/ URL pattern for old mobile app versions.
 */
export const checkMobileWebviewActive = (): boolean => {
  if (Cookies.get(mobileWebviewActiveCookie) === "true") return true;

  // WEBVIEW TODO: Remove once the mobile update has fully rolled out.
  return (
    typeof window !== "undefined" &&
    (window.document.body.hasAttribute("is-react-native-app") ||
      window.location.href.includes("/mobile/"))
  );
};
